import initAnimation from './animations'

export default class Node {
    startTime = 0;
    endTime = 0;
    object = null;
    animations = []

    constructor({ startTime, endTime, object, animations }) {
        this.startTime = startTime * 1000;
        this.endTime = endTime * 1000;
        this.object = object;
        this.animations = initAnimation(animations,  object);
    }

    render(time) {
        if (!this.object) return;

        if (this.startTime <= time && time < this.endTime) {
            this.setShow();
            this.animate(time - this.startTime);
        } else {
            this.setShow(false);
        }
    }

    animate(time) {
        if (!this.animations) return;

        this.animations.forEach(a => a.render(time))
    }

    setShow(isShow = true) {
        if (!this.object) return;

        this.object.set({ opacity: +isShow });
        this.object.set({ clipPath: null });
    }

    getTimesShowFrames() {
        const timesForAnimation = [];

        this.animations.forEach(animation => {
            const startTime = this.startTime + animation.startTime;
            let endTime = this.startTime + animation.endTime;
            endTime = this.endTime < endTime ? this.endTime : endTime;

            timesForAnimation.push(startTime);

            const duration = endTime - startTime;
            const durationFrame = 1000 / 15;

            for (let time = durationFrame; time < duration; time += durationFrame) {
                timesForAnimation.push(startTime + time);
            }

            timesForAnimation.push(endTime);
        });

        return [
          this.startTime,
          ...timesForAnimation,
          this.endTime
        ];
    }
}